import { render, staticRenderFns } from "./StoreButtonList.vue?vue&type=template&id=3ed5449b&"
import script from "./StoreButtonList.vue?vue&type=script&lang=js&"
export * from "./StoreButtonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports